export const MEASUREMENT_DATE_DOCUMENTS_TREE_TEST_IDS = {
  checkbox: (documentReferenceId: number) => `firm-documents-document-checkbox-${documentReferenceId}`,
  companyGroup: (companyId: number) => `firm-documents-company-group-row-${companyId}`,
  companyGroupCheckbox: (companyId: number) => `firm-documents-company-group-checkbox-${companyId}`,
  companyGroupChildren: (companyId: number) => `firm-documents-company-group-children-${companyId}`,
  companyGroupToggle: (companyId: number) => `firm-documents-company-group-toggle-${companyId}`,
  emptyState: 'firm-documents-measurement-date-documents-empty-state',
  emptyUploadDocument: 'firm-documents-measurement-date-documents-empty-upload-document',
  errorState: 'firm-documents-measurement-date-documents-error-state',
  file: (documentReferenceId: number) => `firm-documents-document-row-${documentReferenceId}`,
  fileDragHandle: (documentReferenceId: number) => `firm-documents-document-drag-handle-${documentReferenceId}`,
  fileDragOverlay: 'firm-documents-document-drag-overlay',
  filesWithoutFolder: 'firm-documents-files-without-folder',
  folder: (folderId: number) => `firm-documents-folder-row-${folderId}`,
  folderCheckbox: (folderId: number) => `firm-documents-folder-checkbox-${folderId}`,
  folderChildren: (folderId: number) => `firm-documents-folder-children-${folderId}`,
  folderEmptyState: (folderId: number) => `firm-documents-folder-empty-state-${folderId}`,
  folderToggle: (folderId: number) => `firm-documents-folder-toggle-${folderId}`,
  metadata: (documentReferenceId: number) => `firm-documents-document-metadata-${documentReferenceId}`,
  metadataChip: (documentReferenceId: number, key: string) =>
    `firm-documents-document-metadata-${documentReferenceId}-${key}`,
  root: 'firm-documents-measurement-date-documents-tree',
  rootDropTarget: 'firm-documents-root-drop-target',
  skeleton: 'firm-documents-measurement-date-documents-skeleton',
  showMoreDocuments: 'firm-documents-measurement-date-documents-show-more',
} as const;
